<app-header-one  ></app-header-one>
<router-outlet></router-outlet>
<!-- <app-footer-one ></app-footer-one> -->
 <!-- <app-footer-more-info></app-footer-more-info> -->
<app-peopleflow-footer></app-peopleflow-footer>